import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4282711298 from "../../../../../packages/component/src/components/message/demo/demo1.js?loadDemo";
import legacyImportDemo_3524614785 from "../../../../../packages/component/src/components/message/demo/demo2.js?loadDemo";
import legacyImportDemo_3438038016 from "../../../../../packages/component/src/components/message/demo/demo3.js?loadDemo";
import legacyImportDemo_3761828231 from "../../../../../packages/component/src/components/message/demo/demo4.js?loadDemo";
import legacyImportDemo_2425249030 from "../../../../../packages/component/src/components/message/demo/demo5.js?loadDemo";
import legacyImportDemo_749822085 from "../../../../../packages/component/src/components/message/demo/demo6.js?loadDemo";
import legacyImportDemo_3793144836 from "../../../../../packages/component/src/components/message/demo/demo7.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4282711298,
  legacyImportDemo_3524614785,
  legacyImportDemo_3438038016,
  legacyImportDemo_3761828231,
  legacyImportDemo_2425249030,
  legacyImportDemo_749822085,
  legacyImportDemo_3793144836,
  React
};